$(document).ready(function() {
    const categoryMenu = $('.categories_menu');

    $('.category__title .text').on('click', evt => {
      categoryMenu.addClass('open_popup')
    });

    $('.icon_close').on('click', evt => {
      categoryMenu.removeClass('open_popup')
    });

    $('.category__title_all').on('click', evt => {
      window.location.replace('/pages/blogs');
    });
});